module.exports = __webpack_public_path__ + "cf5efc3b9b797c2f6948fef5831aac28.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/1.m4a
// module id = cuWV
// module chunks = 1